import api from '../../server';

export default {
  namespaced: true,
  state: {
    products: {
      brands:[],
      products:[]
    },
    product:{
      product:{},
      attrValue:[]
    }
  },
  actions:{
    fetchProductList({commit}, {params}) {
      return api.oldProducts(params).then(data => commit('setProductList', {data}))
    },
    fetchProductData({commit}, {params}) {
      return api.oldProduct(params).then(data => commit('setProductData', {data}))
    },
    fetchProductCreate({commit}, {params}) {
      return api.Test(params).then(data => commit('setProductCreate', {data}))
    }
  },
  mutations: {
    setProductList(state,data){
      state.products = data.data.data
    },
    setProductData(state,data){
      state.product = data.data.data
    },
    setProductCreate(state,data){
      state.order = data.data
    }
  }
}
